import { SchemaSection } from '@rossum/api-client/schemas';
import { mapSchemaField } from '../../../schemas/mapSchemaField';

// Takes SchemaSection[] and replaces formula of a field identified by `fieldSchemaId`
export const updateFieldFormula = (
  schemaContent: SchemaSection[],
  fieldSchemaId: string,
  newFormula: string
): SchemaSection[] => {
  return mapSchemaField(schemaContent, fieldSchemaId, datapoint => ({
    ...datapoint,
    formula: newFormula,
  }));
};
